import React from "react";
import { Header, Footer } from "../LandingPage/LandingPage";
import ContactForm from "../../Components/ContactForm/ContactForm";

const socials = [
  {
    name: "Instagram",
    href: "https://instagram.com/gradiance.in",
    color: "text-pink-600",
    label: (
      <a
        href="https://instagram.com/gradiance.in"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        @gradiance.in
      </a>
    ),
    icon: (
      <svg
        width="48px"
        height="48px"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="24" cy="24" r="20" fill="#C13584" />
        <path
          d="M24 14.1622C27.2041 14.1622 27.5837 14.1744 28.849 14.2321C30.019 14.2855 30.6544 14.481 31.0773 14.6453C31.6374 14.863 32.0371 15.123 32.457 15.5429C32.877 15.9629 33.137 16.3626 33.3547 16.9227C33.519 17.3456 33.7145 17.981 33.7679 19.1509C33.8256 20.4163 33.8378 20.7958 33.8378 23.9999C33.8378 27.2041 33.8256 27.5836 33.7679 28.849C33.7145 30.019 33.519 30.6543 33.3547 31.0772C33.137 31.6373 32.877 32.0371 32.4571 32.457C32.0371 32.8769 31.6374 33.1369 31.0773 33.3546C30.6544 33.519 30.019 33.7144 28.849 33.7678C27.5839 33.8255 27.2044 33.8378 24 33.8378C20.7956 33.8378 20.4162 33.8255 19.151 33.7678C17.981 33.7144 17.3456 33.519 16.9227 33.3546C16.3626 33.1369 15.9629 32.8769 15.543 32.457C15.1231 32.0371 14.863 31.6373 14.6453 31.0772C14.481 30.6543 14.2855 30.019 14.2321 28.849C14.1744 27.5836 14.1622 27.2041 14.1622 23.9999C14.1622 20.7958 14.1744 20.4163 14.2321 19.1509C14.2855 17.981 14.481 17.3456 14.6453 16.9227C14.863 16.3626 15.123 15.9629 15.543 15.543C15.9629 15.123 16.3626 14.863 16.9227 14.6453C17.3456 14.481 17.981 14.2855 19.151 14.2321C20.4163 14.1744 20.7959 14.1622 24 14.1622ZM24 12C20.741 12 20.3323 12.0138 19.0524 12.0722C17.7752 12.1305 16.9028 12.3333 16.1395 12.63C15.3504 12.9366 14.6812 13.3469 14.0141 14.0141C13.3469 14.6812 12.9366 15.3504 12.63 16.1395C12.3333 16.9028 12.1305 17.7751 12.0722 19.0524C12.0138 20.3323 12 20.741 12 23.9999C12 27.259 12.0138 27.6676 12.0722 28.9475C12.1305 30.2248 12.3333 31.0971 12.63 31.8604C12.9366 32.6495 13.3469 33.3187 14.0141 33.9859C14.6812 34.653 15.3504 35.0633 16.1395 35.3699C16.9028 35.6666 17.7752 35.8694 19.0524 35.9277C20.3323 35.9861 20.741 35.9999 24 35.9999C27.259 35.9999 27.6677 35.9861 28.9476 35.9277C30.2248 35.8694 31.0972 35.6666 31.8605 35.3699C32.6496 35.0633 33.3188 34.653 33.9859 33.9859C34.653 33.3187 35.0634 32.6495 35.37 31.8604C35.6667 31.0971 35.8695 30.2248 35.9278 28.9475C35.9862 27.6676 36 27.259 36 23.9999C36 20.741 35.9862 20.3323 35.9278 19.0524C35.8695 17.7751 35.6667 16.9028 35.37 16.1395C35.0634 15.3504 34.653 14.6812 33.9859 14.0141C33.3188 13.3469 32.6496 12.9366 31.8605 12.63C31.0972 12.3333 30.2248 12.1305 28.9476 12.0722C27.6677 12.0138 27.259 12 24 12Z"
          fill="white"
        />
        <path
          d="M24.0059 17.8433C20.6026 17.8433 17.8438 20.6021 17.8438 24.0054C17.8438 27.4087 20.6026 30.1675 24.0059 30.1675C27.4092 30.1675 30.1681 27.4087 30.1681 24.0054C30.1681 20.6021 27.4092 17.8433 24.0059 17.8433ZM24.0059 28.0054C21.7968 28.0054 20.0059 26.2145 20.0059 24.0054C20.0059 21.7963 21.7968 20.0054 24.0059 20.0054C26.2151 20.0054 28.0059 21.7963 28.0059 24.0054C28.0059 26.2145 26.2151 28.0054 24.0059 28.0054Z"
          fill="white"
        />
        <path
          d="M31.8507 17.5963C31.8507 18.3915 31.206 19.0363 30.4107 19.0363C29.6154 19.0363 28.9707 18.3915 28.9707 17.5963C28.9707 16.801 29.6154 16.1562 30.4107 16.1562C31.206 16.1562 31.8507 16.801 31.8507 17.5963Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    name: "Email",
    href: "mailto:gradiance.in@gmail.com",
    color: "text-blue-600",
    label: (
      <a href="mailto:gradiance.in@gmail.com" className="hover:underline">
        gradiance.in@gmail.com
      </a>
    ),
    icon: (
      <svg
        width="48px"
        height="48px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6zm3.519 0L12 11.671 18.481 6H5.52zM20 7.329l-7.341 6.424a1 1 0 0 1-1.318 0L4 7.329V18h16V7.329z"
          fill="#0D0D0D"
        />
      </svg>
    ),
  },
  {
    name: "Phone",
    href: "tel:+916376292470",
    color: "text-green-600",
    label: (
      <div className="flex flex-col">
        <a href="tel:+916376292470" className="hover:underline">
          +91 63762 92470
        </a>
        <a href="tel:+918233431894" className="hover:underline">
          +91 82334 31894
        </a>
      </div>
    ),
    icon: (
      <svg
        fill="#000000"
        width="48px"
        height="48px"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21,15v3.93a2,2,0,0,1-2.29,2A18,18,0,0,1,3.14,5.29,2,2,0,0,1,5.13,3H9a1,1,0,0,1,1,.89,10.74,10.74,0,0,0,1,3.78,1,1,0,0,1-.42,1.26l-.86.49a1,1,0,0,0-.33,1.46,14.08,14.08,0,0,0,3.69,3.69,1,1,0,0,0,1.46-.33l.49-.86A1,1,0,0,1,16.33,13a10.74,10.74,0,0,0,3.78,1A1,1,0,0,1,21,15Z"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    ),
  },
];

const ContactPage = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50 text-black">
      <Header />

      <main className="flex-1 py-20 px-4 sm:px-6 lg:px-8 space-y-20">
        <div className="max-w-7xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-10">
          <h2 className="text-4xl font-semibold mb-4 text-gray-800">
            Send Us a Message
          </h2>
          <p className="text-gray-600 text-sm mb-8">
            Have questions, suggestions, or just want to say hi? Fill out the
            form and we'll reach out soon.
          </p>
          <ContactForm />
        </div>

        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-10">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            Connect With Us
          </h2>
          <p className="text-gray-600 text-base mb-8">
            Prefer to reach us directly? Choose any of the methods below.
          </p>

          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {socials.map((item) => (
              <li
                key={item.name}
                className="flex items-start space-x-4 p-4 bg-gray-50 rounded-lg"
              >
                <div className={`text-2xl ${item.color}`}>{item.icon}</div>
                <div>
                  <div className="font-semibold text-lg text-gray-800">
                    {item.name}
                  </div>
                  <div className="text-sm text-gray-600">{item.label}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactPage;
